import API from "./API.js";
import responseModel from "../models/Generic/responseModel";
import { handleApiError } from "./APIErrorManagement.js";

// Store clearUser callback globally so it can be called from error handler
let clearUserCallback = null;
export const setClearUserCallback = (callback) => {
  clearUserCallback = callback;
};

const APICall = {
  post: async function (url, model) {
    let response;
    try {
      response = await API.post(url, model, { withCredentials: true });
    } catch (error) {
      return handleApiError(error, clearUserCallback);
    }
    if (response !== null) {
      let result = response.data;
      if (result.succeeded === true) {
        return new responseModel(
          true,
          result.object,
          null,
          result.additionalMessage,
          result.warnings
        );
      } else {
        return new responseModel(
          false,
          null,
          result.Errors.length > 0
            ? result.Errors[0].Description
            : "There is a problem with the API service."
        );
      }
    } else {
      return new responseModel(
        false,
        null,
        "There is a problem with the API service.",
        null
      );
    }
  },

  get: async function (url) {
    let response;
    try {
      response = await API.get(url, { withCredentials: true });
    } catch (error) {
      return handleApiError(error, clearUserCallback);
    }
    if (response !== null) {
      let result = response.data;
      if (result.succeeded === true) {
        return new responseModel(
          true,
          result.object,
          null,
          result.additionalMessage,
          result.warnings
        );
      } else {
        if (result.Errors !== undefined) {
          return new responseModel(
            false,
            null,
            result.Errors.length > 0
              ? result.Errors[0].Description
              : "There is a problem with the API service."
          );
        } else if (result.errors !== undefined) {
          return new responseModel(
            false,
            null,
            result.errors.length > 0
              ? result.errors[0].Description
              : "There is a problem with the API service."
          );
        }
      }
    } else {
      return new responseModel(
        false,
        null,
        "There is a problem with the API service.",
        null
      );
    }
  },

  put: async function (url, model) {
    let response;
    try {
      response = await API.put(url, model, { withCredentials: true });
    } catch (error) {
      return handleApiError(error, clearUserCallback);
    }
    if (response !== null) {
      let result = response.data;
      if (result.succeeded === true) {
        return new responseModel(
          true,
          result.object,
          null,
          result.additionalMessage,
          result.warnings
        );
      } else {
        let errorMessage =
          result.Errors.length > 0
            ? result.Errors[0].Description
            : "There is a problem with the API service.";
        return new responseModel(false, null, errorMessage);
      }
    } else {
      return new responseModel(
        false,
        null,
        "There is a problem with the API service.",
        null
      );
    }
  },

  delete: async function (url) {
    let response;
    try {
      response = await API.delete(url, { withCredentials: true });
    } catch (error) {
      return handleApiError(error, clearUserCallback);
    }
    if (response !== null) {
      let result = response.data;
      if (result.succeeded === true) {
        return new responseModel(
          true,
          result.object,
          null,
          result.additionalMessage,
          result.warnings
        );
      } else {
        return new responseModel(
          false,
          null,
          result.Errors.length > 0
            ? result.Errors[0].Description
            : "There is a problem with the API service."
        );
      }
    } else {
      return new responseModel(
        false,
        null,
        "There is a problem with the API service.",
        null
      );
    }
  },

  // External PUT for direct uploads (S3, etc.)
  putExternal: async function (url, data, headers = {}) {
    let response;
    try {
      const axios = require("axios");
      response = await axios.put(url, data, { headers });
    } catch (error) {
      return new responseModel(
        false,
        null,
        error.response?.data || error.message || "Upload failed"
      );
    }

    if (response && response.status >= 200 && response.status < 300) {
      return new responseModel(true, response.data, null);
    } else {
      return new responseModel(
        false,
        null,
        response?.statusText || "Upload failed"
      );
    }
  },
};

export default APICall;
